/* HM - carrusel de testimonios estilo Facebook (flechas y puntos) */
(function () {
  function init(raiz) {
    (raiz || document).querySelectorAll('[data-hm-fb]:not([data-hm-listo])').forEach(function (caja) {
      caja.setAttribute('data-hm-listo', '1');
      var pista = caja.querySelector('[data-hm-pista]');
      var items = [].slice.call(caja.querySelectorAll('[data-hm-item]'));
      var puntos = caja.querySelector('[data-hm-puntos]');
      var prev = caja.querySelector('[data-hm-prev]');
      var next = caja.querySelector('[data-hm-next]');
      if (!pista || items.length < 1) return;
      var botones = [];

      function porVista() {
        var w = pista.clientWidth, iw = items[0].getBoundingClientRect().width;
        return Math.max(1, Math.round(w / (iw || w)));
      }
      function paginas() { return Math.max(1, items.length - porVista() + 1); }
      function indice() {
        var x = pista.scrollLeft, mejor = 0, dist = 1e9;
        items.forEach(function (it, i) {
          var d = Math.abs(it.offsetLeft - pista.offsetLeft - x);
          if (d < dist) { dist = d; mejor = i; }
        });
        return Math.min(mejor, paginas() - 1);
      }
      function ir(i) {
        i = Math.max(0, Math.min(i, paginas() - 1));
        pista.scrollTo({ left: items[i].offsetLeft - pista.offsetLeft, behavior: 'smooth' });
      }
      function dibujar() {
        if (!puntos) return;
        puntos.innerHTML = ''; botones = [];
        var n = paginas();
        if (n < 2) { caja.classList.add('hm-sin-nav'); return; }
        caja.classList.remove('hm-sin-nav');
        for (var i = 0; i < n; i++) {
          (function (k) {
            var b = document.createElement('button');
            b.type = 'button'; b.className = 'hm-fb__punto'; b.setAttribute('aria-label', 'Testimonio ' + (k + 1));
            b.addEventListener('click', function () { ir(k); });
            puntos.appendChild(b); botones.push(b);
          })(i);
        }
        marcar();
      }
      function marcar() {
        var i = indice();
        botones.forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i >= paginas() - 1;
      }
      var t;
      pista.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(marcar, 60); }, { passive: true });
      if (prev) prev.addEventListener('click', function () { ir(indice() - 1); });
      if (next) next.addEventListener('click', function () { ir(indice() + 1); });
      window.addEventListener('resize', function () { dibujar(); });
      dibujar();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
